// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"96":"vendors","470":"vendor.chart.js"}[chunkId] + "." + {"96":"85f94829","470":"29cbb59b"}[chunkId] + ".js";
};